import Product from './Product.view';

export default Product;
